import BaseApplication from './base.js';

const $ = require('jquery');
global.$ = global.jQuery = $;

import stickybits from 'stickybits';

'use strict';

export class PageApplication extends BaseApplication {
	constructor(args = []) {
		super(args);

		this.setLog('[Extension] ', "Page");

		// sticky
		stickybits('#header', { useStickyClasses: true });
		stickybits('#sticky', { stickyBitStickyOffset: 60 });

		// accordion
		$(function() {
	        $('.sidemenu .trigger').click(function() {
	            $(this).next('ul').slideToggle();
	            $(this).parent('li').toggleClass('active');

	            $('.sidemenu .trigger').not($(this)).next('ul').slideUp();
	        });
	    });
	}

	callback() {
		this.showPerfomance();
		return null;
	}
};

// if(typeof window.Application == "undefined" || window.Application == null) {
	window.Application = new PageApplication();
// }